import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressService } from './wordpress.service';

@Injectable({
  providedIn: 'root'
})
export class LaboService extends WordpressService {

	get baseUrl () {return 'labo/wp-json/wp/v2/'};
	get baseHeaders () {

		const authentication: string = /*{

			'qdion@oxance.fr': 'cWRpb246aWVIUiAyWkswIElWV2cgZHdxQyBpclZkIDd2cmU=',
			'jclairet@oxance.fr': 'amNsYWlyZXQ6YlF6NiBVM3pnIHZwYmUgQkhMUiBjT3FxIGZYc3k=',
			'achen@oxance.fr': 'YWNoZW46Q2NmeiA3clpxIHkzVGkga21jSSB1RWZFIE9GZTc=',
			'david.souchon@oxance.fr': 'ZGF2aWQuc291Y2hvbjppZW5FIDlnSkIgekxaWCBwNjFHIGRGOHggU0NpTQ==',
			'jmcapuano@oxance.fr': 'am1jYXB1YW5vOm50RFQgbnVQQSBrU3VKIDVtUUEgS3JzNyBmQ1Fu',
			'lcordaro@oxance.fr': 'bGNvcmRhcm86UTVvYiBGTXVMIFIxYk8gZVU1YSBOVlBPIHJzeVU=',
			'pchion@oxance.fr': 'cGNoaW9uOlRxcjQga05xQyBwRVJxIE1IbE8gYnRRcCBQNk8w',
			'phery@oxance.fr': 'cGhlcnk6c1RNRSBKVlZtIHRPaGsgamJ1RCAxWmlZIFdEc2s=',
			'remy.allard@oxance.fr': 'cmVteS5hbGxhcmQ6bFVISiBaRkxlIGxZQ0EgVTltOCBOek9WIGpWRTg=',
			'thanina.imarazene@oxance.fr': 'dGhhbmluYS5pbWFyYXplbmU6UUxFViBpZlgzIGlMajYgaDNRZSA3d1N1IGhTdXI='

		}[this.me.mail] ??*/ 'cG9ydGFpbDpRWlk0IHdJbnogMGdJUyBzY1R1IDJwMHogVDdBeg==';
		
		return {'Authorization': `Basic ${authentication}`}
	};

	constructor(http: HttpClient) { super(http); }
}